module.exports = __webpack_public_path__ + "static/media/exterminador_b.111363c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/exterminador_b.png
// module id = 1157
// module chunks = 0